import UserBonusesPage from './UserBonusesPage';

export default UserBonusesPage;
